// extracted by mini-css-extract-plugin
export default {"container":"kl-z","blurb":"ll-z","links":"ml-z"};